import { GroupePiecesDto, PieceDto } from '@/shared/services/service-clients'
import { Component, Input, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import { Samv2Module } from '@aubert-et-duval/samv2';

@Component({
  selector: 'app-info-bar',
  imports: [CommonModule, Samv2Module],
  templateUrl: './info-bar.component.html',
  styleUrls: ['./info-bar.component.scss'],
})
export class InfoBarComponent {
  private _querySubs$!: Subscription
  private _filterSubs$!: Subscription
  private _notFoundSubs$!: Subscription

  @Input()
  filtersNumber!: number

  @Input()
  resultsNumber!: number

  @Input()
  notFoundNumber!: number

  constructor(public translate: TranslateService) {}
}
